import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { te } from "date-fns/locale";
import { textFieldClasses } from "@mui/material";
// import ButtonTranslation from "../../Traduccion_ES_EN/ButtonTraslation";

//*Archivos de referencia para la traduccion
// import { useTranslation } from "react-i18next";
// import "../../Traduccion_ES_EN/i18nMiCuenta";

i18n
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .init({
    resources: {
      en: {
        translation: {
          Welcome: {
            text1: "My Account",
            text2: "Modify personal data",
            text3: "Name",
            text4: "Admin",
            text5: "Update profile",
            text6: "Modify access data",
            text7: "Current password",
            text8: "New password",
            text9: "Change password",
            text10: "My service",
            text11: "Add service",
            text12: "Name",
            text13: "Type of service",
            text14: "Creation date",
            text15: "Time zone",
            text16: "Status",
            text17: "Enable",
            text18: "Disable",
            text19: "Add company",
            text20: "Please fill in the company information",
            text21: "Company name",
            text22: "Type of company",
            text23: "Upload logo",
            text24: "Save",
            text25: "Cancel",
            text26: "Exit",
            text27: "Update",
            text28: "Add Company",
            text29: "Please fill in the company information below.",
            text30: "Company Name",
            text31: "Company Type",
            text32: "Upload Logo",
            text33: "My Services",
            text34: "Add Service",
            text35: "Creation date",
            text36: "Time zone",
            text37: "Active",
            text38: "Inactive",
            text39: "Change Status",
            text40:
              "Are you sure you want to change the status of the service ",
            text41: "Not Answered",
            text42: "Client Hung Up",
            text43: "Finished",
            text44: "Waiting List",
            text45: "General Information - Folio #",
            text46: "Service",
            text47: "Identifier",
            text48: "Folio",
            text49: "Recording",
            text50: "Assignment Date",
            text51: "Closing Date",
            text52: "Folio Status",
            text53: "Last Classification",
            text54: "Duration Time (sec)",
            text55: "Messages",
            text56: "Send Date",
            text57: "Send Time",
            text58: "Message",
            text59: "Message Type",
            text60: "Search",
            text61: "No data to show",
            text62: "Search by Folio Number",
            text63: "Here is an example of FOLIO",
            text64: "Choose a service",
            text65: "Choose a Report",
            text66:
              "You don't have lists, add new lists to be able to consult them.",
            text67: "Folio ligth reports",
            text68: "Blaster Reports",
            text69: "Reports",
            text70: "SMS Reports",
            text71: "Graph Reports",
            text72: "Map Reports",
            text73: "Cabin",
            text74: "New",
            text75: "Attention",
            text76: "Saved",
            text77: "Transferred",
            text78: "Finished",
            text79: "BOT Attention",
            text80: "Voice Mail",
            text81: "Failure",
            text82: "Waiting List",
            text83: "Phone",
            text84: "Date he dialed",
            text85: "Status",
            text86: "No data found",
            text87: "Call report by Status",
            text88: "Call report by day",
            text89: "Pages",
            text90: "No data",
            text91: "Audio",
            text92: "Folio Status",
            text93: "Agent",
            text94: "Case ID",
            text95: "Identifier",
            text96: "Call Type",
            text97: "Start Date",
            text98: "End Date",
            text99: "Duration (sec)",
            text100: "Call Date",
            text101: "Call Duration (sec)",
            text102: "Delivered",
            text103: "Not Delivered",
            text104: "General Information",
            text105: "Users",
            text106: "Service",
            text107: "Applications",
            text108: "Lists",
            text109: "This field is required",
            text110: "Only letters are accepted",
            text111: "and special characters",
            text112: "Service Name",
            text113: "Initial Greeting",
            text114: "All",
            text115: "Supervisor",
            text116: "Quality",
            text117: "Suspended",
            text118: "Low",
            text119: "Delete",
            text120: "User",
            text121: "Profile",
            text122: "Search by user or name",
            text123: "Selected Profile",
            text124: "Edit",
            text125: "Add User",
            text126: "Edit User",
            text127: "Number of simultaneous attentions",
            text128: "Password",
            text129: "Delete user",
            text130: "Are you sure you want to delete ",
            text131: "Some fields are empty.",
            text132: "accept at least 8 characters",
            text133: "accept maximum 15 characters",
            text134: "contains at least one uppercase letter",
            text135: "contains at least one lowercase letter",
            text136: "contains at least one digit",
            text137: "does not accept spaces",
            text138: "contains at least one special character: eg. $@$!%*?&",
            text139: "The password must have the following characteristics: ",
            text140: "Remove",
            text141: "Loading data...",
            text142: "Home",
            text143: "Service Options",
            text144: "Subject",
            text145: "Keyword",
            text146: "Add",
            text147: "Add Classification",
            text148: "New Classification",
            text149: "Add CRM",
            text150: "New CRM",
            text151: "Queue Name",
            text152: "Queue Subject",
            text153: "Delete Classification",
            text154: "Delete Queue",
            text155: "Delete CRM",
            text156: "Are you sure you want to delete ",
            text157: "The maximum characters are 15",
            text158: "Only numbers are accepted",
            text159: "The maximum characters are 1",
            text160: "Only from 0 to 9 are accepted",
            text161: "Department",
            text162: "Dialer",
            text163: "Search by department",
            text164: "Diagram",
            text165: "No matches found",
            text166: "IVR Diagram",
            text167: "Add New IVR",
            text168: "number",
            text169: "message",
            text170: "Enter a number",
            text171: "Enter a message",
            text172: "SMSformat.xlsx ",
            text173: "Active IVR",
            text174: "enter client name",
            text175: "Calls",
            text176: "Format",
            text177: "Upload your Outbound files, for this service",
            text178:
              "By not selecting *Schedule Campaign*, the campaign will be launched instantly.",
            text179: "Campaign Name",
            text180: "Process file",
            text181: "Schedule campaign",
            text182: "File",
            text183: "Search by List Name",
            text184: "Active Lists",
            text185: "Manage your lists from here.",
            text186: "You do not yet have active call lists.",
            text187: "Delete Response",
            text188: "Are you sure you want to delete the list ",
            text189: "Log In",
            text190: "Log Out",
            text191: "Add New Queue",
            text192: "Scheme",
            text193: "Select a date and time to launch your campaign.",
            text194: "Start Date",
            text195: "End Date",
            text196: "Lists",
            text197: "Cost report",
            text198: "Cost",
            text199: "List Reports",
            text200: "Adjusters ready",
            text201: "Connected Adjusters",
            text202: "Disconnected Adjusters",
            text203: "Adjusters on attention",
            text204: "No data",
            text205: "Agents Report by Status",
            text206: "Adjusters",
            text207: "List of online Adjusters",
            text208: "Open Tickets",
            text209: "Number of expired tickets",
            text210: "Adjusters in conversation",
            text211: "Number of expired tickets",
            text212: "Tickets Abiertos",
            text213: "Active Questions",
            text214: "Search by question",
            text215: "Add",
            text216: "Only Spanish",
            text217: "Total surveys answered",
            text218: "New Question",
            text219: "Question",
            text220: "Form Report",
            text221: "List",
            text222: "Total calls",
            text223: "Total minutes",
            text224: "Total cost",
            text225:
              "Spanish Only’ option: If you select this option, you will only be able to add questions in Spanish. If you do not select this option, you will be able to add questions in both Spanish and English.",
            text226: "Call made",
            text227: "Call ended",
            text228: "Seconds duration",
            text229: "Cost",
            text230: "List",
            text231: "Programming date",
            text232: "Creation date",
            text233: "Clasifications",
            text234: "Voice",
            text235: "IVR",
            text236:
              "Enter H or M depending on the type of voice you want (Male or Female).",
            text237: "Enter IVR channel(1 or 2)",
            text238: "Queues Waiting",
            text239: "Upload Records",
            text240: "Send Records",
            text241: "You can upload your CSV file to generate user records.",
            text242: "Queue",
            text243: "Resolution Time",
            text244: "Passwords do not match, please verify.",
            text245: "Reason",
            text246: "Some fields are incorrect, please verify.",
            text247: "Estimated Closing Date",
            text248: "Confirm Password",
            text249: "Select an option",
            text250: "Connection error. Please contact the administrator.",
            text251: "Queue",
            text252: "Line error. Please contact the administrator.",
            text253: "Outbound Calls",
            text254: "Send to Queues",
            text255: "Outbound",
            text256: "You don’t have any active lists yet",
            text257: "No active lists",
            text258: "On-site Management",
            text259: "Field Records",
            text260: "Field",
            text261: "Blaster",
            text262: "Send to Blaster",
            text263: "SMS",
            text264: "CSV File",
            text265: "Unable to establish the connection.",
            text266: "This field is required.",
            text267: "Only numbers are allowed.",
            text268: "formatSMS.xlsx",
            text269: "formatCalls.xlsx",
            text270: "formatOutboundCalls.csv",
            text271: "formatLocation.csv",
            text272: "Sheet1",
            text273: "Select the agent",
            text274: "Add more columns...",
            text275: "Enter a number",
            text276: "Enter a Queue",
            text277: "Add more data...",
            text278: "PHONE",
            text279: "QUEUE",
            text280: "ADDRESS",
            text281:
              "Add an address, e.g., Av. Paseo de la Reforma 305, Cuauhtémoc, 06500 Mexico City, CDMX",
            text282: "You cannot delete the +52 prefix",
            text283: "Calling to ",
            text284: "There are no active calls.",
            text285: "Call History",
            text286: "You don’t have any dialed numbers yet.",
            text287: "Call Service",
            text288: "T.S. Name",
            text289: "T.S. Service",
            text290: "T.S. Anchor",
            text291: "T.S. Private Token",
            text292: "T.S. Public Token",
            text293: "Service Cost",
            text294: "Record Call",
            text295: "Status",
            text296: "User Actions",
            text297: "WhatsApp Status",
            text298: "Return to Master",
            text299: "Adjusters on the road",
            text300: "Adjuster",
            text301: "Region / Zona de atencion",
            text302: "New Region",
            text303: "v 2.6.1",
            text304: "Did you forget your password?",
          },
        },
      },
      es: {
        translation: {
          Welcome: {
            text1: "Mi cuenta",
            text2: "Modificar datos personales",
            text3: "Nombre",
            text4: "Administrador",
            text5: "Actualizar perfil",
            text6: "Modificar datos de acceso",
            text7: "Contraseña actual",
            text8: "Nueva contraseña",
            text9: "Cambiar contraseña",
            text10: "Mis servicios",
            text11: "Agregar servicio",
            text12: "Nombre",
            text13: "Tipo de servicio",
            text14: "Fecha de creación",
            text15: "Zona horaria",
            text16: "Estado",
            text17: "Activar",
            text18: "Desactivar",
            text19: "Añadir empresa",
            text20:
              "Por favor rellene la información de la empresa a continuación",
            text21: "Nombre de la empresa",
            text22: "Tipo de empresa",
            text23: "Subir logo",
            text24: "Guardar",
            text25: "Cancelar",
            text26: "Salir",
            text27: "Actualizar",
            text28: "Añadir Empresa",
            text29:
              "Por favor, rellene la información de la empresa a continuación.",
            text30: "Nombre de la Empresa",
            text31: "Tipo de Empresa",
            text32: "Subir Logotipo",
            text33: "Mis Servicios",
            text34: "Agregar Servicio",
            text35: "Fecha de creación",
            text36: "Zona horaria",
            text37: "Activo",
            text38: "Inactivo",
            text39: "Cambiar Estatus",
            text40:
              "¿Estás seguro de que deseas cambiar el status de el servicio ",
            text41: "No Atendido",
            text42: "El Cliente colgó",
            text43: "Finalizada",
            text44: "Pila de espera",
            text45: " Información General - Folio #",
            text46: "Servicio",
            text47: "Identificador",
            text48: "Folio",
            text49: "Grabación",
            text50: "Fecha de asignación",
            text51: "Fecha de cierre",
            text52: "Estado de folio",
            text53: "Ultima clasificación",
            text54: "Tiempo de Duracion (sec)",
            text55: "Mensajes",
            text56: "Fecha de envio",
            text57: "Hora de envio",
            text58: "Mensaje",
            text59: "Tipo de mensaje",
            text60: "Buscador",
            text61: "No hay datos para mostrar",
            text62: "Buscar por Número de Folio",
            text63: "Aqui va un ejemplo de FOLIO",
            text64: "Elige un servicio",
            text65: "Elige un Reporte",
            text66:
              "No tienes listas, agrega nuevas listas para poder consultarlas.",
            text67: "Reportes de folio ligth",
            text68: "Reportes blaster",
            text69: "Reportes",
            text70: "Reportes de SMS",
            text71: "Reportes de Graficas",
            text72: "Reportes de Mapas",
            text73: "Cabina",
            text74: "Nuevo",
            text75: "Atención",
            text76: "Guardado",
            text77: "Transferido",
            text78: "Finalizado",
            text79: "Atención BOT",
            text80: "Buzon de Voz",
            text81: "Fallo",
            text82: "Pila de espera",
            text83: "Telefono",
            text84: "Fecha en que marcó",
            text85: "Estatus",
            text86: "No se encontraron datos",
            text87: "Reporte de llamadas por Estatus",
            text88: "Reporte de llamadas por día",
            text89: "Páginas",
            text90: "Sin datos",
            text91: "Audio",
            text92: "Estado del Folio",
            text93: "Agente",
            text94: "ID Caso",
            text95: "Identificador",
            text96: "Tipo de llamada",
            text97: "Fecha de inicio",
            text98: "Fecha final",
            text99: "Duracion (seg)",
            text100: "Fecha de llamada",
            text101: "Duración de llamada(seg)",
            text102: "Entregado",
            text103: "No Entregado",
            text104: "Información General",
            text105: "Usuarios",
            text106: "Servicio",
            text107: "Aplicaciones",
            text108: "Listas",
            text109: "Este campo es obligatorio",
            text110: "Solo se aceptan letras",
            text111: "y caracteres especiales",
            text112: "Nombre del Servicio",
            text113: "Saludo Inicial",
            text114: "Todos",
            text115: "Supervisor",
            text116: "Calidad",
            text117: "Suspendido",
            text118: "Baja",
            text119: "Eliminar",
            text120: "Usuario",
            text121: "Perfil",
            text122: "Buscar por usuario o nombre",
            text123: "Perfil seleccionado",
            text124: "Editar",
            text125: "Agregar Usuario",
            text126: "Editar Usuario",
            text127: "Número de atenciones simultáneas",
            text128: "Contraseña",
            text129: "Eliminar Usuario",
            text130: "Estás seguro de que deseas eliminar a ",
            text131: "Algunos campos se encuentran vacíos.",
            text132: "acepta al menos 8 caracteres",
            text133: "acepta máximo 15 caracteres",
            text134: "contiene al menos una letra mayúscula",
            text135: "contiene al menos una letra minúscula",
            text136: "contiene al menos un dígito",
            text137: "no acepta espacios en blanco",
            text138: "contiene al menos un caractér especial: ej. $@$!%*?&",
            text139:
              "La contraseña debe tener las siguientes características: ",
            text140: "Quitar",
            text141: "Cargar datos...",
            text142: "Inicio",
            text143: "Opciones de servicio",
            text144: "Asunto",
            text145: "Palabra clave",
            text146: "Agregar",
            text147: "Agregar Clasificación",
            text148: "Nueva Clasificación",
            text149: "Agregar CRM",
            text150: "Nuevo CRM",
            text151: "Nombre del Queue",
            text152: "Asunto del Queue",
            text153: "Eliminar Clasificación",
            text154: "Eliminar CRM",
            text155: "Eliminar Queue",
            text156: "Estás seguro de que deseas eliminar ",
            text157: "El maximo de caracteres son 15",
            text158: "Solo se aceptan números",
            text159: "El maximo de caracteres son 1",
            text160: "Solo se aceptan del 0 al 9",
            text161: "Departamento",
            text162: "Marcador",
            text163: "Buscar por departamento",
            text164: "Diagrama",
            text165: "No hay coincidencias",
            text166: "Diagrama IVR",
            text167: "Agregar Nuevo IVR",
            text168: "numero",
            text169: "mensaje",
            text170: "Ingrese un número",
            text171: "Ingrese un mensaje",
            text172: "formato SMS.xlsx",
            text173: "IVR Activos",
            text174: "ingresa nombre del cliente",
            text175: "Llamadas",
            text176: "Formato",
            text177: "Sube tus archivos Outbound, para este servicio",
            text178:
              " Al no seleccionar *Programar Campaña*, la campaña será lanzada instantáneamente.",
            text179: "Nombre de la Campaña",
            text180: "Procesar archivo",
            text181: "Programar Campaña",
            text182: "Archivo",
            text183: "Buscar por nombre de Lista",
            text184: "Listas activas",
            text185: "Administra tus listas desde aquí.",
            text186: "Aún no cuentas con listas activas de ",
            text187: "Eliminar Respuesta",
            text188: "Estas seguro que quieres eliminar la lista ",
            text189: "Iniciar Sesión",
            text190: "Cerrar Sesión",
            text191: "Agregar Nuevo Queue",
            text192: "Esquema",
            text193: "Seleccione una fecha y hora para lanzar su campaña.",
            text194: "Fecha inicio",
            text195: "Fecha fin",
            text196: "Listas",
            text197: "Reporte de costos",
            text198: "Costo",
            text199: "Reporte de Listas",
            text200: "Ajustadores Listos",
            text201: "Ajustadores conectados",
            text202: "Ajustadores desconectados",
            text203: "Ajustadores en atención",
            text204: "No se encontraron datos",
            text205: "Reporte de Agentes por Estatus",
            text206: "Ajustadores",
            text207: "Lista de ajustadores en línea",
            text208: "Tickets Abiertos",
            text209: "Número de tickets vencidos",
            text210: "Ajustadores en ruta",
            text211: "Número de tickets vencidos",
            text212: "Tickets Abiertos",
            text213: "Preguntas Activas",
            text214: "Buscar por pregunta",
            text215: "Agregar",
            text216: "Solo Español",
            text217: "Total de encuestas contestadas",
            text218: "Nueva Pregunta",
            text219: "Pregunta",
            text220: "Reporte de formulario",
            text221: "Listas",
            text222: "Total llamadas",
            text223: "Total minutos",
            text224: "Costo total",
            text225:
              'Opción "Solo Español": Si seleccionas esta opción, solo podrás agregar preguntas en español. Si no seleccionas esta opción, podrás agregar preguntas en ambos idiomas, español e inglés.',
            text226: "Llamada Realizada",
            text227: "Llamada finalizada",
            text228: "Duración en segundos",
            text229: "Costos",
            text230: "Lista",
            text231: "Fecha de programación",
            text232: "Fecha de Creación",
            text233: "Clasificaciones",
            text234: "Voice",
            text235: "IVR",
            text236:
              "Ingrese H o M dependiendo del tipo de voz que desea(Hombre o Mujer)",
            text237: "Ingrese canal de IVR(1 o 2)",
            text238: "Queues en Espera",
            text239: "Subir Registros",
            text240: "Enviar Registros",
            text241:
              "Puedes subir tu archivo CSV para generar registros de usuarios.",
            text242: "Queue",
            text243: "Tiempo de Resolucion",
            text244: "Las contraseñas no coinciden, favor de verificar.",
            text245: "Motivo",
            text246: "Algunos campos son incorrectos, favor de verificar",
            text247: "Fecha estima de cierre",
            text248: "Confirmar contraseña",
            text249: "Selecciona una opción",
            text250: "Error en la conexión. Contacte al administrador.",
            text251: "Queue",
            text252: "Error en la linea. Contacte al administrador",
            text253: "Llamadas Outbound",
            text254: "Enviar a Queues",
            text255: "Outbound",
            text256: "Aún no cuentas con listas activas",
            text257: "No hay listas activas",
            text258: "Gestión Presencial",
            text259: "Registros de Campo",
            text260: "Campo",
            text261: "Bláster",
            text262: "Enviar a Blaster",
            text263: "SMS",
            text264: "Archivo CSV",
            text265: "No se pudo enlazar la conexión.",
            text266: "Este campo es obligatorio",
            text267: "Solo se aceptan números.",
            text268: "formatSMS.xlsx",
            text269: "formatCalls.xlsx",
            text270: "formatOutboundCalls.csv",
            text271: "formatLocation.csv",
            text272: "Sheet1",
            text273: "Selecciona el agente",
            text274: "Agregar mas columnas..",
            text275: "Ingrese un numero",
            text276: "Ingresa un Queue",
            text277: "Agrega mas datos..",
            text278: "TELEFONO",
            text279: "QUEUE",
            text280: "DIRECCION",
            text281:
              "Agrega una direccion, Ej. Av. Paseo de la Reforma 305, Cuauhtémoc, 06500 Ciudad de México, CDMX",
            text282: "No puedes borrar el prefijo +52",
            text283: "Llamando a : ",
            text284: "No hay ninguna llamada activa.",
            text285: "Historial de Llamadas",
            text286: "Aún no tienes números marcados.",
            text287: "Servicio de llamadas",
            text288: "T.S. Nombre",
            text289: "T.S. Servicio",
            text290: "T.S. Anchor",
            text291: "T.S. Private Token",
            text292: "T.S. Public Token",
            text293: "Costo del Servicio",
            text294: "Grabar Llamada",
            text295: "Estado",
            text296: "Acciones de Usuario",
            text297: "Estado de WhatsApp",
            text298: "Volver a Master",
            text299: "Ajustadores en ruta",
            text300: "Ajustador",
            text301: "Region / Zona de atencion",
            text302: "Nueva Región",
            text303: "v 2.6.1",
            text304: "¿Olvidaste tu contraseña?",
          },
        },
      },
    },
    lng: sessionStorage.getItem("lang"), // if you're using a language detector, do not define the lng option
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });

export default i18n;
